module.exports = __webpack_public_path__ + "static/media/image_10.bee45288.png";